import React from "react";

type CardProps = {
  title?: React.ReactNode;
  sub?: React.ReactNode;
  action?: React.ReactNode;
  pad?: boolean;
  children: React.ReactNode;
};

export function Card({ title, sub, action, pad = false, children }: CardProps) {
  return (
    <div className="card">
      {(title || action) && (
        <div className="card-head">
          <div>
            {title && <h3 className="card-title">{title}</h3>}
            {sub && <div className="card-sub">{sub}</div>}
          </div>
          {action && <div style={{ marginLeft: "auto" }}>{action}</div>}
        </div>
      )}
      {pad ? <div className="card-pad">{children}</div> : children}
    </div>
  );
}
